export default __webpack_public_path__ + "locales/ru/InfoPanel.json?hash=8d5d5d004bc63fef19c0604f0211b211";